import type { ReactElement } from "react"

import type { Moment } from "moment"

import type { Report } from "../../types/generated/api/Report"
import type { SimulationJobRetrieve } from "../../types/generated/api/SimulationJobRetrieve"
import type { WorkflowVersionRetrieve } from "../../types/generated/api/WorkflowVersionRetrieve"

export interface TopDataFeaturesProps {
  features: Array<{ name: string; values: Record<number | string, number> }>
  label: string
}

export interface ReportV1Props {
  simulation: SimulationJobRetrieve
  reportData: Report
  isReportResLoading: boolean
  predictionDateRange: ReactElement | undefined
}

export interface PieChartContainerProps {
  isLoading: boolean
  index: number
  data: {
    reasons: { name: string; value: number; percent: number }[]
    label: { name: string; percent: number; value: number }
  }[]
}

export interface SimulationCreationDialogProps {
  open: boolean
  onClose: () => void
  workflowID: string
  workflowName: string
}

export interface ExistingDatasetViewProps {
  setDataFile: (uuid: string, columns: string[]) => void
}

export interface LiveDataViewProps {
  setFormikStartDate: (date?: Moment) => void
  setFormikEndDate: (date?: Moment) => void
  setFormikRequestsNumber: (data: number) => void
}

export interface NewDatasetViewProps {
  workflow: WorkflowVersionRetrieve
  setDataFile: (uuid: string, columns: string[]) => void
}

export enum SimulationTagMap {
  "Running" = "yellow",
  "Failed" = "red",
  "Success" = "green",
  "Partial Success" = "orange",
  "Pending" = "blue",
}
